import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles } from "lucide-react";
import api from "@/lib/api";

/** One-shot static-burst celebration when the Discord crosses a member milestone. */
export default function Celebration() {
  const [celebration, setCelebration] = useState(null);

  useEffect(() => {
    api.get("/discord/live")
      .then((r) => {
        const c = r.data?.celebration;
        if (!c?.milestone) return;
        const seenKey = `inj-celebrated-${c.milestone}`;
        if (sessionStorage.getItem(seenKey)) return;
        sessionStorage.setItem(seenKey, "1");
        setCelebration(c);
      })
      .catch(() => {});
  }, []);

  return (
    <AnimatePresence>
      {celebration && (
        <motion.div
          initial={{ y: -60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -60, opacity: 0 }}
          className="fixed top-20 inset-x-0 z-40 flex justify-center px-4 pointer-events-none"
          data-testid="celebration-banner"
        >
          <div className="pointer-events-auto border border-white/25 bg-black/90 backdrop-blur px-6 py-3 flex items-center gap-3 celebration-glitch">
            <Sparkles size={14} className="text-white animate-pulse" />
            <span className="font-mono text-[11px] tracking-[0.25em] text-white">
              // {celebration.milestone} MEMBERS IN THE CORD — THANK YOU
            </span>
            <button onClick={() => setCelebration(null)} data-testid="celebration-dismiss"
              className="font-mono text-[10px] text-white/40 hover:text-white ml-2">✕</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
